import { css } from 'styled-components';

const renderCssBasedOnColorScheme = ({ light, dark }) => {
  return css([
    ``,
    ``
  ], (p) => {
    switch (p.theme.userColorScheme) {
      case "dark":
        return css([
          ``,
          ` `,
          ``
        ], light, dark);
      case "system":
        return css([
          ``,
          ` @media (prefers-color-scheme:dark){`,
          `}`
        ], light, dark);
      case "light":
      default:
        return css([
          ``,
          ``
        ], light);
    }
  });
};

export { renderCssBasedOnColorScheme };
//# sourceMappingURL=renderCssBasedOnColorScheme.js.map
